
import { CachedData } from "../types/types";

export const setCachedData = <T,>(key: string, data: T) => {
  if (typeof window === 'undefined') return;
  try {
    const item: CachedData<T> = {
      timestamp: new Date().getTime(),
      data: data,
    };
    localStorage.setItem(key, JSON.stringify(item));
  } catch (error) {
    console.error(`Error saving data to localStorage for key "${key}":`, error);
  }
};

export const getCachedData = <T,>(key: string, maxAgeMinutes: number): T | null => {
  if (typeof window === 'undefined') return null;
  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item: CachedData<T> = JSON.parse(itemStr);
    const now = new Date().getTime();
    const maxAgeMs = maxAgeMinutes * 60 * 1000;

    if (now - item.timestamp > maxAgeMs) {
      localStorage.removeItem(key);
      return null;
    }
    return item.data;
  } catch (error) {
    console.error(`Error reading or parsing data from localStorage for key "${key}":`, error);
    localStorage.removeItem(key); // Clear corrupted item
    return null;
  }
};

export const removeCacheData = () => {
  if (typeof window === 'undefined') return null;

  localStorage.clear(); 
}